import React from "react";
import { CONTACT_EMAIL, INSTAGRAM_URL } from "../../config/site";

/**
 * Cierre de la home: consulta comercial e Instagram.
 */
const ContactBand = () => (
	<section id="contacto" className="anchor-target bg-ink py-16 text-white lg:py-[105px]">
		<div className="shell">
			<p className="eyebrow !text-white/60">Contacto</p>

			<div className="mt-4 grid items-end gap-8 lg:grid-cols-[1fr_auto] lg:gap-20">
				<h2 className="display-2 max-w-[850px]">
					¿Necesitás información sobre alguna marca o promoción?
				</h2>

				<a className="button button--light w-full sm:w-auto" href={ `mailto:${CONTACT_EMAIL}` }>
					Contactar al equipo comercial <span aria-hidden="true">→</span>
				</a>
			</div>

			<a
				className="mt-10 inline-flex items-center gap-2.5 text-xs font-semibold text-white/70 transition-colors duration-200 hover:text-white"
				href={ INSTAGRAM_URL }
				target="_blank"
				rel="noreferrer"
			>
				<svg viewBox="0 0 24 24" aria-hidden="true" className="h-[18px] w-[18px] fill-none stroke-current" strokeWidth={1.6}>
					<rect x="3" y="3" width="18" height="18" rx="5"></rect>
					<circle cx="12" cy="12" r="4"></circle>
					<circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"></circle>
				</svg>
				Seguinos en Instagram
			</a>
		</div>
	</section>
);

export default ContactBand;
